// src/api/apiHotelRoomCategories.js
import axios from "../utils/axios";

/// Get Hotel Room Categories
export const getAllHotelRoomCategories = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("hotel-room-categories", { params });
    return data;
};

/// Get Hotel Room Category
export const getHotelRoomCategory = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`hotel-room-categories/${id}`);
    return data;
};

/// Create Hotel Room Category
export const createHotelRoomCategory = async (req) => {
    try {
        const { data } = await axios.post("hotel-room-categories", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createHotelRoomCategory error:", error);
        throw error;
    }
};

/// Update Hotel Room Category
export const updateHotelRoomCategory = async (req, id) => {
    try {
        const { data } = await axios.put(`hotel-room-categories/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateHotelRoomCategory error:", error);
        throw error;
    }
};

/// Delete Hotel Room Category
export const deleteHotelRoomCategory = async (id) => {
    try {
        const { data } = await axios.delete(`hotel-room-categories/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteHotelRoomCategory error:", error);
        throw error;
    }
};

/// Delete All Hotel Room Categories
export const deleteAllHotelRoomCategories = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "hotel-room-categories/mass-destroy",
            { data: { items: ids } },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("deleteAllHotelRoomCategories error:", error);
        throw error;
    }
};

/// Restore Hotel Room Category
export const restoreHotelRoomCategory = async (id) => {
    try {
        const { data } = await axios.post(`hotel-room-categories/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreHotelRoomCategory error:", error);
        throw error;
    }
};

/// Restore multiple Hotel Room Categories
export const restoreAllHotelRoomCategories = async (ids = []) => {
    try {
        const { data } = await axios.post(
            "hotel-room-categories/mass-restore",
            { items: ids },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("restoreAllHotelRoomCategories error:", error);
        throw error;
    }
};

/// Force Delete Hotel Room Category
export const forceDeleteHotelRoomCategory = async (id) => {
    try {
        const { data } = await axios.delete(`hotel-room-categories/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteHotelRoomCategory error:", error);
        throw error;
    }
};

/// Force Delete multiple Hotel Room Categories
export const forceDeleteAllHotelRoomCategories = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "hotel-room-categories/mass-force-delete",
            { data: { items: ids } },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("forceDeleteAllHotelRoomCategories error:", error);
        throw error;
    }
};

/// Get Hotel Room Categories for Select Dropdown
export const getHotelRoomCategoriesForSelect = async () => {
    try {
        const { data } = await axios.get("hotel-room-categories/for-select");
        return data;
    } catch (error) {
        console.error("getHotelRoomCategoriesForSelect error:", error);
        throw error;
    }
};
